export default function prepareApiUrl(str = '') {
	if (!str) {
		return '';
	}

	let newStr = str?.endsWith('/') ? str?.slice(0, -1) : str;

	return newStr?.endsWith('/v1') ? newStr : newStr + '/v1';
}
